// @ts-nocheck
import { REQUEST_HELP_ERROR, REQUEST_HELP_LOADING, REQUEST_HELP_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const request_help = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: REQUEST_HELP_LOADING,
                data: true
            })
            Authservices.request_help(data).then((data) => {
                if (data?.status === 200) {
                    dispatch({
                        type: REQUEST_HELP_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: REQUEST_HELP_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}